{ avatarDomain } = require '@trello/config'
t = require('app/scripts/views/internal/teacup-with-helpers')()

module.exports = t.renderable ({ members }) ->
  for { avatarHash, viewTitle, initials, icon } in members
    t.span '.edit-in-progress', ->
      t.span '.inline-member', ->
        title = viewTitle
        if avatarHash
          t.img '.inline-member-av', { src: [avatarDomain, avatarHash, '30.png'].join('/'), alt: title, title }
        else
          t.span '.quiet.initials', { title }, ->
            t.text initials
      if icon
        t.icon icon, class: 'icon'
